import dashboard from "./dashboard";
import products from "./products";

export const stocks = {
    dashboard,
    products,
};

export default stocks;
